import { render, staticRenderFns } from "./FactItem.vue?vue&type=template&id=1dbed18c&functional=true"
import script from "./FactItem.vue?vue&type=script&lang=js"
export * from "./FactItem.vue?vue&type=script&lang=js"
import style0 from "./FactItem.vue?vue&type=style&index=0&id=1dbed18c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports